// app/plugins/auth-init.client.ts - 预先恢复登录态，避免首屏登录按钮闪烁
export default defineNuxtPlugin(() => {
  const userStore = useUserStore()
  try { userStore.initFromStorage() } catch (e) {
    // eslint-disable-next-line no-console
    console.warn('[auth-init] initFromStorage failed', e)
  }
})

// 保持 nuxt 自动导入
import { useUserStore } from '~/stores/user'
